import { ArrowLeftOutlined, DatabaseOutlined, ReloadOutlined } from '@ant-design/icons';
import { Alert, Breadcrumb, Button, Spin } from 'antd';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { EmptyState } from '../../components/EmptyState';
import { PageHeader } from '../../components/PageHeader';
import { useCategoriasList } from './api/useCatalogosAdmin';
import { CatalogosTable } from './components/CatalogosTable';

export function CatalogosCategoryPage() {
  const navigate = useNavigate();
  const { category: encodedCategory } = useParams<{ category: string }>();
  const categoryCode = encodedCategory ? decodeURIComponent(encodedCategory) : '';
  const { data: categories, isLoading, isError, refetch } = useCategoriasList();
  const category = categories?.find((item) => item.code === categoryCode);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 56 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (isError) {
    return (
      <Alert
        type="error"
        showIcon
        message="No se pudo cargar la categoría"
        action={
          <Button icon={<ReloadOutlined />} onClick={() => void refetch()}>
            Reintentar
          </Button>
        }
      />
    );
  }

  if (!category) {
    return (
      <EmptyState
        title="Categoría no encontrada"
        description="La categoría que intentás consultar no existe o fue desactivada."
        action={
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/catalogos')}>
            Volver a catálogos
          </Button>
        }
      />
    );
  }

  return (
    <div>
      <PageHeader
        breadcrumb={
          <Breadcrumb
            items={[
              { title: <Link to="/">Inicio</Link> },
              {
                title: (
                  <Button
                    type="link"
                    icon={<DatabaseOutlined />}
                    onClick={() => navigate('/catalogos')}
                    style={{ padding: 0, height: 'auto' }}
                  >
                    Catálogos
                  </Button>
                ),
              },
              { title: category.name },
            ]}
          />
        }
        title={category.name}
        subtitle={category.description ?? `Administración de ${category.name.toLowerCase()}.`}
      />
      <CatalogosTable category={category} />
    </div>
  );
}
